<template>
    <div :class="`us-map`">
        <svg-map 
            @click="setState"
            :location-class="assignNarrativeClasses"
            :map="stateMap"
            v-show="narrative != 'technology'">
        </svg-map>
        <svg-map 
            @click="setState"
            :location-class="assignTechClasses"
            :map="countiesMap"
            v-show="narrative == 'technology'">
        </svg-map>
        <div :class="`us-map__key ${narrative == 'technology' ? 'us-map__key--technology' : ''}`">
            <div class="us-map__key-title">Number of {{narrative == 'technology' ? 'Impressions' : 'Campaigns Supported by DSPolitical'}}</div>
            <div class="us-map__key-options">
                <div class="us-map__key-option us-map__key-option--20">
                    <div :class="`us-map__key-option__narrative--${narrative}`"></div>
                </div>
                <div class="us-map__key-option us-map__key-option--40">
                    <div :class="`us-map__key-option__narrative--${narrative}`"></div>
                </div>
                <div class="us-map__key-option us-map__key-option--60">
                    <div :class="`us-map__key-option__narrative--${narrative}`"></div>
                </div>
                <div class="us-map__key-option us-map__key-option--80">
                    <div :class="`us-map__key-option__narrative--${narrative}`"></div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    import { SvgMap } from "vue-svg-map";
    import countiesMap from "@svg-maps/usa.counties";
    import stateMap from "@svg-maps/usa";
    import impressionStats from '../../constants/impressionStats.json';

    export default {
        name: 'narrative-map',
        components: {
            SvgMap,
        },
        props: {
            stateStats: Object,
            narrativeNames: Array,
            narrativeTotals: Object,
            nationalTotal: Object,
            narrative: String,
        },
        data: function(){
            return {
                impressionStats: impressionStats,
                countiesMap: countiesMap,
                stateMap: stateMap,
            }
        },
        watch: {
            narrative: function(val, oldVal){
                this.setNarrative(val, oldVal);
            }
        },
        mounted(){
            this.setNarrative(this.narrative);
        },
        methods: {
            assignTechClasses(location){
                if(location){
                    let gradient = 'none';
                    let locationClass = 'state-shape__technology';
        
                    const impressionStat = impressionStats[location.id];
                    if(impressionStat){
                        gradient = (`${impressionStat.impressions}`.length * 10);
                    } 
                    
                    return `${locationClass}--on ${locationClass} ${locationClass}--${gradient}`;
                }
            },
            assignNarrativeClasses(location){
                if(location){
                    const state = location.id.slice(-2).toUpperCase();
                    let classes = [`state-shape__${state}`, 'state-shape', 'state-shape__all'];
                    
                    this.narrativeNames.forEach((narrative) => {
                        if(this.stateStats[state].narratives[narrative] > 0){
                            classes.push(`state-shape__${narrative}`);
                        }

                        if(narrative != 'technology'){
                            const narrativeRacesInState = narrative === 'all' ? this.stateStats[state].races.total.count : this.stateStats[state].narratives[narrative];
                            const narrativeRacesInUS = narrative === 'all' ? this.nationalTotal.count : this.narrativeTotals[narrative];
                            const narrativeRacesPercentage = ((narrativeRacesInState / narrativeRacesInUS * 100));
                            classes.push(this.assignNarrativeGradients(narrative, narrativeRacesPercentage))
                        }
                    })

                    return classes.join(' ');
                }
            },

            assignNarrativeGradients(narrative, rate){
                if(rate == 0){
                    return `state-shape__${narrative}--none`;
                } else if (rate > 3){
                    return `state-shape__${narrative}--80`;
                } else if (rate > 2){
                    return `state-shape__${narrative}--60`;
                } else if(rate > 1){
                    return `state-shape__${narrative}--40`;
                } else if (rate > 0){
                    return `state-shape__${narrative}--20`;
                }
            },
            setState($event){
                // This check accounts for the white space around the map
                if($event.target.id.length > 0){
                    this.$router.push({ 
                        name: 'state', 
                        params: {
                            state: $event.target.id.slice(-2).toLowerCase() 
                        }
                    });
                }
            },
            setNarrative(val, oldVal = null){
                // if user switches from one narrative to another
                if(val != oldVal){
                    // remove the old narrative theme
                    let oldPaths = document.querySelectorAll(`.state-shape__${oldVal}`);
                    oldPaths.forEach(path => {
                        path.classList.remove(`state-shape__${oldVal}--on`);
                    });
                }

                // assign narrative theme to map
                let paths = document.querySelectorAll(`.state-shape__${val}`);
                paths.forEach(path => {
                    path.classList.add(`state-shape__${val}--on`);
                });
            }
        }
    }
</script>
<style lang="scss">
    @import "../../styles/_variables.scss";
    @import "../../styles/_mixins.scss";

    .us-map.svg-map{
        display: flex;
        align-items: center;
        justify-content: center;
        margin-bottom: 5vh;
        max-width: 800px;
        margin: 0 auto;
        flex-direction: column;
        @media screen and (min-width: $large-screens){
            align-items: center;
        }
        svg{
            @media screen and (min-width: $desktop){
                min-height: 400px;
                max-width: 700px;
            }
        }
    }

    .state-shape{
        fill: $default;
        stroke: $white;
        stroke-opacity: 1;
        fill-opacity: .2;
        stroke-width: 0.75;
        stroke-miterlimit: 4;
        stroke-dasharray: none;
        transition: fill-opacity .3s;
        transition: fill .3s;
        transition-timing-function: ease;

        &__HI {
          transform: rotate(-40deg);
          transform-origin: 60% 85%;
        }
        &__MI:hover ~ &__MI{
            cursor: pointer;
            fill-opacity: 1;
            transition: fill-opacity .3s;
            transition-timing-function: ease
        }
        &:hover{
            cursor: pointer;
            fill-opacity: 1;
            transition: fill-opacity .3s;
            transition-timing-function: ease;
        }
        &--none{
            fill-opacity: .1;
            &:hover{
                cursor: pointer;
                fill-opacity: .1;
            }
        }
    } 

    .state-shape__all--on.state-shape__all{
        @include stateShade($all);
    }

    .state-shape__aapi--on.state-shape__aapi{
        @include stateShade($aapi);
    }
    
    .state-shape__flipped--on.state-shape__flipped{
        @include stateShade($flipped);
    }

    .state-shape__women--on.state-shape__women{
        @include stateShade($women);
    }

    .state-shape__poc--on.state-shape__poc{
       @include stateShade($poc);
    }

    .state-shape__new--on.state-shape__new{
        @include stateShade($new);
    }
    
    .state-shape__lgbtq--on.state-shape__lgbtq{
        @include stateShade($lgbtq);
    }

    .state-shape__gotv--on.state-shape__gotv{
        @include stateShade($gotv);
    }

    .state-shape__latino--on.state-shape__latino{
        @include stateShade($latino);
    }

    .state-shape__aapi--on.state-shape__aapi{
        @include stateShade($aapi);
    }

    .state-shape__native_american--on.state-shape__native_american{
        @include stateShade($nativeAmerican);
    }

    .state-shape__black--on.state-shape__black{
        @include stateShade($black);
    }

    .us-map__key {
        display: flex;
        width: 100%;
        flex-direction: column;
        align-items: center;
        margin-left: 90px;
        margin-top: -36px;

        &.us-map__key--technology {
            margin-left: 0;
            margin-top: 0;
        }
    }

    .us-map__key-title{
        font-size: 10px;
        margin-bottom: .5%;

        @media screen and (max-width: 450px){
            max-width: 125px;
            text-align: center;
        }
    }

    .us-map__key-options{
        height: 20px;
        width: 20vw;
        display: flex;
        @media screen and (min-width: $desktop){
            width: 10vw;
        }
    }
    .us-map__key-option{
        flex: 1;
        // background-color: $default;
        margin-right: 1px;
        &--20{
            opacity: $opacity20;
        }
        &--40{
            opacity: $opacity40;
        }
        &--60{
            opacity: $opacity60;
        }
        &--80{
            opacity: $opacity80;
        }
        &__narrative--all{
            @include narrativeKey($all);
        }
        &__narrative--lgbtq{
            @include narrativeKey($lgbtq);
        }
        &__narrative--women{
            @include narrativeKey($women);
        }
        &__narrative--new{
            @include narrativeKey($new);
        }
        &__narrative--flipped{
            @include narrativeKey($flipped);
        }
        &__narrative--poc{
            @include narrativeKey($poc);
        }
        &__narrative--gotv{
            @include narrativeKey($gotv);
        }
        &__narrative--technology{
            @include narrativeKey($technology);
        }
        &__narrative--latino{
            @include narrativeKey($latino);
        }
        &__narrative--aapi{
            @include narrativeKey($aapi);
        }
        &__narrative--native_american{
            @include narrativeKey($nativeAmerican);
        }
        &__narrative--black{
            @include narrativeKey($black);
        }
    }
    .svg-map__location{
        &.state-shape__technology{
            fill: $default;
        }
        &.state-shape__technology--on.state-shape__technology{
            @include stateShade($technology);
        }
    }
</style>
